import React, { useEffect, useState } from 'react';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { clear, setItem } from '../../utils/localStorage';
import { authMeAPI } from './../../requests/login';
import { showErrorMessage } from '../../helpers/showMessage';
import { handleBrandAndHotelData } from '../../helpers/handleBrandAndHotelData';
import { trackSessionStart } from '../../utils/myLqaAnalytics';
import { Level } from '../../enums/Level';
import { ClearAllIndexedDB } from '../../indexed';

const DirectLogin = () => {
  localStorage.removeItem('day');
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get('token');
  const email = params.get('email');
  const phone = params.get('phone');
  const pin = params.get('isPinLogin');
  const sessionId = params.get('sessionId');
  const selectedHotelId = params.get('selectedHotel');
  const selectedClientId = params.get('selectedClient');
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    ClearAllIndexedDB();
    clear();
    authMeAPI(token)
      .then((authResponse) => {
        if (!authResponse) {
          showErrorMessage('Unauthorised User');
          setIsLoading(false);
          window.location.href = '/login';
        } else {
          setItem('user', JSON.stringify(authResponse));
          setItem('userProfile', JSON.stringify(authResponse.userProfile));
          setItem('sessionId', sessionId);
          const pinSet = authResponse.user
            ? authResponse.user.isPinSet
            : authResponse.userProfile.isPinSet;
          setItem('changePinSet', pinSet);
          if (email) {
            setItem('login-email', email);
          } else if (phone) {
            setItem('login-phone', phone);
            setItem('phonenumber', phone);
          }
          if (pin) {
            setItem('login-pin', true);
          }
          const userData = authResponse;
          if (
            userData &&
            userData.user &&
            userData.user.brands &&
            userData.user.brands.length
          ) {
            if (selectedHotelId && selectedHotelId !== 'null') {
              setItem('selectedHotel', selectedHotelId);
            }
            if (selectedClientId && selectedClientId !== 'null') {
              setItem('selectedClient', selectedClientId);
            }
            handleBrandAndHotelData(userData.user.brands);
          }
          if (userData && userData.user && (userData.accessToken || token)) {
            trackSessionStart();
          }
          setItem('hotelList', []);
          setItem('iosApp', true);
          setTimeout(() => {
            setIsLoading(false);
            if (authResponse && authResponse.user && authResponse.user.level) {
              if (
                authResponse.user.level === Level.staff ||
                authResponse.user.level === Level.teamLead
              ) {
                window.location.href = '/myactions';
              } else {
                window.location.href = '/dashboard';
              }
            } else {
              window.location.href = '/dashboard';
            }
          }, 1000);
        }
      })
      .catch(() => {
        showErrorMessage('Unauthorised User');
        setIsLoading(false);
        window.location.href = '/login';
      });
  }, []);
  return <>{isLoading ? <LoadingContent /> : <></>}</>;
};

export default DirectLogin;
